/**
 * Domains filter for search
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';

import { Col, Label } from 'design-react-kit';
import { Checkbox } from 'design-comuni-plone-theme/components';

const messages = defineMessages({
  parma_search_for_domain: {
    id: 'parma_search_for_domain',
    defaultMessage: 'Cerca nel dominio',
  },
});

export default function SearchDomains({
  domains,
  domainsFilter,
  setDomainsFilter,
  cols,
}) {
  const intl = useIntl();

  return (
    <>
      {domains.map((d) => {
        if (d[1] === 0) {
          return null;
        }
        const domain = d[0];
        return (
          <Col sm={cols ? 12 / cols : 12} key={domain} className="group-col">
            <Checkbox
              id={domain}
              checked={domainsFilter === domain}
              onChange={() =>
                setDomainsFilter(domain === domainsFilter ? '' : domain)
              }
              aria-controls="search-results-region"
              aria-label={
                intl.formatMessage(messages.parma_search_for_domain) +
                ' ' +
                domain
              }
            />

            <Label
              check
              for={domain}
              tag="label"
              className="group-head text-primary ellipsis"
              widths={['xs', 'sm', 'md', 'lg', 'xl']}
              title={domain}
            >
              {domain.replace(/^www\./, '')}
            </Label>
          </Col>
        );
      })}
    </>
  );
}

SearchDomains.propTypes = {
  domains: PropTypes.arrayOf(PropTypes.array).isRequired,
  domainsFilter: PropTypes.objectOf(PropTypes.bool).isRequired,
  setDomainsFilter: PropTypes.func.isRequired,
  cols: PropTypes.number,
};
